<script setup lang="ts">
defineProps({ blok: Object });

const { state } = useAppStore();
</script>

<template>
  <div class="relative">
    <div v-motion-slide-visible-once-top>
      <img :src="blok?.package?.filename" :alt="blok?.image?.alt" class="h-[300px]" />
    </div>
  </div>
</template>
